import { isNew } from './datetime'

export function isNumber(number) {
  return !Number.isNaN(+number) && Number.isFinite(+number);
}

export function getTitle(title, brandTitle = true) {
  const baseTitle = 'MyPersonality';
  if (brandTitle) {
    return title ? `${title} - ${baseTitle}` : baseTitle
  }
  return title || baseTitle;
}

export function getNewLabel(createdAt) {
  return isNew(createdAt) ? 'New' : '';
}

export const prepareCardBrand = (brand) => {
  switch (brand) {
  case 'american-express':
    return 'amex';
  case 'mastercard':
    return 'master';
  case 'discover':
    return 'discover';
  case 'maestro':
    return 'maestro';
  case 'diners-club':
    return 'diners';
  case 'hipercard':
    return 'hipercard';
  case 'elo':
    return 'elo';
  default:
    return 'visa';
  }
};

export const getSEOKeywords = (seo) => {
  const focusKeyword = seo?.focus_keyword
  const focusSynonyms = seo?.focus_synonyms
  const keywords = [];
  if (focusKeyword) {
    keywords.push(focusKeyword);
  }
  if (focusSynonyms && focusSynonyms.length > 0) {
    keywords.push(...focusSynonyms);
  }
  return keywords;
};

export const getSEOProps = (seo, {defaultTitle = ''} = {}) => ({
  title: seo?.seo_title || defaultTitle,
  description: seo?.meta_description,
  image: seo?.image,
  keywords: getSEOKeywords(seo),
  brandTitle: !seo?.seo_title
})